
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/subscription-terms",
      function () {
        return require("private-next-pages/subscription-terms.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/subscription-terms"])
      });
    }
  